// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import Vuex from 'vuex';
import VueMoment from 'vue-moment';
import VueScrollTo from 'vue-scrollto';
import Meta from 'vue-meta';
import VueNumeralFilter from 'vue-numeral-filter';
import VueFullPage from 'vue-fullpage.js';
import VueGtm from 'vue-gtm';
import App from './App';
import router from './router';
import store from '../src/store/index';

Vue.use(Vuex);
Vue.use(VueMoment);
Vue.use(VueCookies);
Vue.use(VueScrollTo);
Vue.use(VueNumeralFilter);
Vue.use(VueFullPage);
Vue.use(Meta);
Vue.use(VueGtm, {
    id: 'GTM-5N5XD6V',
    /*
    queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
      gtm_auth:'AB7cDEf3GHIjkl-MnOP8qr',
      gtm_preview:'env-4',
      gtm_cookies_win:'x'
    },
    */
    enabled: true,
    debug: false,
    loadScript: true,
    vueRouter: router,
    // ignoredViews: ['homepage'],
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js